import { useState } from 'react';
import { useI18n } from 'core/i18n/I18nProvider';
import { localizedName, safeHttpUrl } from 'shared/utilities/format';

export function SpecialistAvatar({
  specialist,
  className = 'avatar',
  lazy = false,
  size = 40,
}) {
  const { t, locale } = useI18n();
  const [broken, setBroken] = useState(false);
  const name = localizedName(specialist, locale)
    || specialist?.name_en
    || specialist?.name_ar
    || specialist?.name
    || '';
  const initials = (name || '?').trim().slice(0, 1).toUpperCase();
  const url = safeHttpUrl(specialist?.avatar_url);
  const showImage = Boolean(url) && !broken;

  if (showImage) {
    return (
      <img
        className={className}
        src={url}
        alt={name ? t('specialists.avatarAlt', { name }) : t('specialists.currentImage')}
        width={size}
        height={size}
        loading={lazy ? 'lazy' : undefined}
        decoding="async"
        onError={() => setBroken(true)}
      />
    );
  }

  return (
    <span
      className="avatar-fallback"
      aria-hidden={Boolean(name)}
      title={name || undefined}
      style={{ width: size, height: size }}
    >
      {initials}
    </span>
  );
}
